
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M7.52 4.146a3.679 3.679 0 002.094-.867 3.679 3.679 0 014.772 0c.59.502 1.322.805 2.094.867a3.679 3.679 0 013.374 3.374c.062.772.365 1.505.867 2.094a3.679 3.679 0 010 4.772 3.679 3.679 0 00-.867 2.094 3.679 3.679 0 01-3.374 3.374 3.678 3.678 0 00-2.094.867 3.679 3.679 0 01-4.772 0 3.678 3.678 0 00-2.094-.867 3.679 3.679 0 01-3.374-3.374 3.679 3.679 0 00-.867-2.094 3.679 3.679 0 010-4.772c.502-.59.805-1.322.867-2.094A3.679 3.679 0 017.52 4.146zm8.929 6.302a1.2 1.2 0 00-1.698-1.697L10.8 12.703 9.249 11.15a1.2 1.2 0 10-1.698 1.697l2.4 2.4a1.2 1.2 0 001.698 0l4.8-4.8z","fill":"#fff"}})])
          )
        }
      }
    